<template>
  <div class="popUpWrap">
    <section class="popup dark subscription">
      <div class="topArea">
        <div class="exit" @click.stop="dialogStore.close" />
      </div>
      <div class="scrollY">
        <div class="icon rec"></div>
        <div class="textArea flex">
          <h5>{{ t('organization-subscription-cancel-subscription-title') }}</h5>
        </div>
        <div class="boxArea">
          <div class="titleArea">
            <p>{{ t('pricing-current-plan') }}</p>
            <h5>{{ dialogStore.options.props.planName ?? '' }}</h5>
          </div>
          <ul class="listDot">
            <li
                v-if="dialogStore.options.props.status === SubscriptionStatus.ACTIVE"
                v-html="t('organization-subscription-cancel-subscription-description-1', { date: `<span>${dialogStore.options.props.endDate}</span>` })"
            />
            <li>{{ t('organization-subscription-cancel-subscription-description-3') }}</li>
            <li>{{ t('organization-subscription-cancel-subscription-description-4') }}</li>
            <li v-if="dialogStore.options.props.isPro">{{ t('organization-subscription-cancel-subscription-description-2') }}</li>
          </ul>
        </div>
        <div class="btnArea">
          <button type="button" class="cancel" @click.stop="dialogStore.close">
            {{ t('common-cancel') }}
          </button>
          <button type="button" @click.stop="onClickCancelSubscription">
            {{ t('organization-subscription-cancel-subscription') }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import {useDialogStore} from '~/store/dialog/dialogStore';
import {SubscriptionStatus} from '~~/package/mapper/subscription/model/SubscriptionStatusType';

const { t } = useI18n();
const dialogStore = useDialogStore();

const onClickCancelSubscription = () => {
  dialogStore.close();
  dialogStore.options.confirm?.event();
}
</script>